import store from '@/store'
import { i18n } from '@/main.js'

export default {
  getPlatfomrListForSelectBox() {
    const platformList = store.getters['Platform/getPlatformListFromState']
    return platformList.map((ele) => {
      return {
        label: ele.name,
        value: ele.platformId,
        platformCountryId: ele.platformCountryId
      }
    })
  },
  getPlatformById(id) {
    const platformList = store.getters['Platform/getPlatformListFromState']
    return platformList.find((v) => v.platformId == id)
  },
  getPlatformCountryList() {
    return [
      {
        value: 33,
        label: `${i18n.tc('common.country_china')}EC`
      },
      {
        value: 88,
        label: `${i18n.tc('common.country_japan')}EC`
      }
    ]
  },
  getPlatformCountryById(platformCountryId) {
    return this.getPlatformCountryList().find(
      (ele) => ele.value == platformCountryId
    )
  },
  getCurrencyIdByPlatformCurrencyId(platformCurrencyId) {
    const currencyMapPlatformCurrency = [
      // 中国
      { platformCurrency: 33, currencyId: 2 },
      // 日本
      { platformCurrency: 88, currencyId: 1 }
    ]

    return currencyMapPlatformCurrency.find(
      (v) => v.platformCurrency == platformCurrencyId
    ).currencyId
  }
}
